import React from "react";
import "./footer.css";

const Footer = () => {
  return <div className="footer">Lorem ipsum dolor sit amet.</div>;
};

export default Footer;
